import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Zoom from "react-reveal/Zoom";
import { Fade } from "react-reveal";
import nyc from "../../images/nyc.png";
import ci from "../../images/onboarding.png";
import hd from "../../images/hd.png";
import pp from "../../images/portfolio.png";
import key from "../../images/Keyboard.avif";
import cms from "../../images/cms.png";
import { FaCode } from "react-icons/fa";
import { Link } from "react-router-dom";
import meal from "../../images/meal.png";
import sims from "../../images/sims.png";
import { HiArrowRight } from "react-icons/hi";

export default function Projects() {
  return (
    <div>
      <Container fluid className="certificate-section" id="about">
        <Container>
          <Row>
            <Col md={12} className="certificate-description d-flex justify-content-start">
              <Zoom left cascade>
                <h1 className="aboutme-heading">Projects</h1>
              </Zoom>
            </Col>
            <Row className="g-4"> {/* Added g-4 for gutter spacing between columns */}
              <Col md={3} sm={6}>
                <Fade bottom>
                  <div
                    className="singleProject"
                    style={{
                      backgroundColor: "rgb(142 70 186 / 31%)",
                      border: "1px solid",
                      height: "100%" // Ensure equal height
                    }}
                  >
                    <div className="projectContent">
                      <h5 id={"first"} style={{ color: "#fbd9ad" }}>
                        Power Failure Prediction System
                      </h5>
                      <img src={meal} alt={meal} style={{ width: "100%", height: "auto" }} />
                      <div className="project--showcaseBtn">
                        <a
                          href={"https://ijisrt.com/assets/upload/files/IJISRT23JUL424.pdf"}
                          target="_blank"
                          rel="noreferrer"
                          className={"iconBtn"}
                          aria-labelledby={`code`}
                        >
                          <FaCode
                            id={`code`}
                            className={"icon"}
                            aria-label="Code"
                          />
                        </a>
                      </div>
                    </div>
                    <h6>
                      <p
                        className="project--desc"
                        style={{
                          background: "#fbd9ad",
                          color: "#b061df",
                          fontWeight: 600,
                        }}
                      >
                        AI system that predicts three-phase power failures by analyzing 
                        voltage fluctuations and current imbalances. Detects single-phasing 
                        conditions and provides early warnings.
                      </p>
                    </h6>
                    <div
                      className="project--lang"
                      style={{
                        background: "#fbd9ad",
                        color: "#b061df",
                        fontWeight: 600,
                      }}
                    >
                      Python, TensorFlow, Scikit-learn
                    </div>
                  </div>
                </Fade>
              </Col>

              <Col md={3} sm={6}>
                <Fade bottom>
                  <div
                    className="singleProject"
                    style={{
                      backgroundColor: "rgb(142 70 186 / 31%)",
                      border: "1px solid",
                      height: "100%"
                    }}
                  >
                    <div className="projectContent">
                      <h5 id={"first"} style={{ color: "#fbd9ad" }}>
                        Weather Prediction Using AI/ML
                      </h5>
                      <img src={ci} alt={ci} style={{ width: "100%", height: "auto" }} />
                      <div className="project--showcaseBtn">
                        <a
                          href={"https://github.com/kghthor/Weather-Prediction-DL"}
                          target="_blank"
                          rel="noreferrer"
                          className={"iconBtn"}
                          aria-labelledby={`code`}
                        >
                          <FaCode
                            id={`code`}
                            className={"icon"}
                            aria-label="Code"
                          />
                        </a>
                      </div>
                    </div>
                    <h6>
                      <p
                        className="project--desc"
                        style={{
                          background: "#fbd9ad",
                          color: "#b061df",
                          fontWeight: 600,
                        }}
                      >
                        Deep Learning model to predict weather conditions. Helps meteorologists 
                        and administrators for better interpretation during extreme weather events.
                      </p>
                    </h6>
                    <div
                      className="project--lang"
                      style={{
                        background: "#fbd9ad",
                        color: "#b061df",
                        fontWeight: 600,
                      }}
                    >
                      LSTM, RNN, DL
                    </div>
                  </div>
                </Fade>
              </Col>

              <Col md={3} sm={6}>
                <Fade bottom>
                  <div
                    className="singleProject"
                    style={{
                      backgroundColor: "rgb(142 70 186 / 31%)",
                      border: "1px solid",
                      height: "100%"
                    }}
                  >
                    <div className="projectContent">
                      <h5 id={"first"} style={{ color: "#fbd9ad" }}>
                        ATM Card Fraud Detection
                      </h5>
                      <img src={hd} alt={hd} style={{ width: "100%", height: "auto" }} />
                      <div className="project--showcaseBtn">
                        <a
                         href={"https://github.com/kghthor/ATM-Fraud-Detection"}
                          target="_blank"
                          rel="noreferrer"
                          className={"iconBtn"}
                          aria-labelledby={`code`}
                        >
                          <FaCode
                            id={`code`}
                            className={"icon"}
                            aria-label="Code"
                          />
                        </a>
                      </div>
                    </div>
                    <h6>
                      <p
                        className="project--desc"
                        style={{
                          background: "#fbd9ad",
                          color: "#b061df",
                          fontWeight: 600,
                        }}
                      >
                        Minimizes false alerts in ATM transactions using machine learning. 
                        Detects fraud with Decision Tree, SVM and K-Nearest Neighbour algorithms.
                      </p>
                    </h6>
                    <div
                      className="project--lang"
                      style={{
                        background: "#fbd9ad",
                        color: "#b061df",
                        fontWeight: 600,
                      }}
                    >
                      ML Algorithms
                    </div>
                  </div>
                </Fade>
              </Col>

              <Col md={3} sm={6}>
                <Fade bottom>
                  <div
                    className="singleProject"
                    style={{
                      backgroundColor: "rgb(142 70 186 / 31%)",
                      border: "1px solid",
                      height: "100%"
                    }}
                  >
                    <div className="projectContent">
                      <h5 id={"first"} style={{ color: "#fbd9ad" }}>
                        Disaster Intensity Prediction
                      </h5>
                      <img src={sims} alt={sims} style={{ width: "100%", height: "auto" }} />
                      <div className="project--showcaseBtn">
                        <a
                          href={"https://github.com/kghthor/Disaster-Intensity-Prediction"}
                          target="_blank"
                          rel="noreferrer"
                          className={"iconBtn"}
                          aria-labelledby={`code`}
                        >
                          <FaCode
                            id={`code`}
                            className={"icon"}
                            aria-label="Code"
                          />
                        </a>
                      </div>
                    </div>
                    <h6>
                      <p
                        className="project--desc"
                        style={{
                          background: "#fbd9ad",
                          color: "#b061df",
                          fontWeight: 600,
                        }}
                      >
                        Analyzes historical disaster data to predict severity and likelihood 
                        of future events with geospatial analysis and climate data.
                      </p>
                    </h6>
                    <div
                      className="project--lang"
                      style={{
                        background: "#fbd9ad",
                        color: "#b061df",
                        fontWeight: 600,
                      }}
                    >
                      Python, GeoPandas, XGBoost
                    </div>
                  </div>
                </Fade>
              </Col>
            </Row>

            <div className="blog--viewAll mt-4">
              <Link to="/projectspage">
                <button className="btn btn-primary">
                  View All
                  <HiArrowRight className="viewArr" />
                </button>
              </Link>
            </div>
          </Row>
        </Container>
      </Container>
    </div>
  );
}